module.exports = __webpack_public_path__ + "static/media/loading.231f5f52.gif";